import React from "react";
import Coin from "./Coin";

const BettersListCard = ({ bets }) => {
  return (
  <div className="absolute top-100 left-4 sm:left-15 w-40 sm:w-64 z-50 mt-6 sm:mt-3">
      <div className="bg-white/0 rounded-xl">
        <div className="p-1 sm:p-4">
          {bets && bets.length > 0 ? (
            <div className="betters-scroll-outer max-h-32 sm:max-h-64 overflow-hidden">
              <ul className="space-y-0.5 sm:space-y-2 betters-scroll-inner">
                {bets.map((bet, i) => (
                  <li
                    key={i}
                    className="flex items-center justify-between p-0.5 sm:p-2 rounded-lg hover:bg-gray-100 transition"
                  >
                    <span className="font-semibold text-black truncate text-[10px] sm:text-sm" style={{ background: 'rgba(255,255,255,0.35)', borderRadius: '6px', padding: '1px 6px' }}>
                      {bet.username || `Joueur ${i + 1}`}
                    </span>
                    <span className="text-[10px] sm:text-sm text-green-600 font-semibold flex items-center gap-1">
                      <Coin amount={bet.amount} symbol="HTG" />
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default BettersListCard;